import AuthGuard from 'utils/route-guard/AuthGuard';
import ChatLayout from '../views/chat/ChatLayout';
// import ChatPage from 'views/chat';

const ChatRoutes = {
  path: '/chat',
  element: (
    <AuthGuard>
      <ChatLayout />
    </AuthGuard>
  )
  // children: [
  //   {
  //     index: true,
  //     element: <ChatPage />
  //   }
  // ]
};

export default ChatRoutes;
